export { SelectDropDownComponent } from './components';
export { SelectDropDownModule } from './ngx-select-dropdown.module';
//# sourceMappingURL=index.js.map